export const PARTNER_MIGRATION_SSR_USERS_INFO = 'PARTNER_MIGRATION_SSR_USERS_INFO';
export const PARTNER_DASHBOARD_UNLOCK_CLASS_LEVEL_CAMPAIGNS = 'PARTNER_DASHBOARD_UNLOCK_CLASS_LEVEL_CAMPAIGNS';
export const PARTNER_DASHBOARD_SMARTSPOT_ONBOARDING = 'PARTNER_DASHBOARD_SMARTSPOT_ONBOARDING';
export const PARTNER_DASHBOARD_SMARTSPOT_CHART = 'PARTNER_DASHBOARD_SMARTSPOT_CHART';
export const PARTNER_DASHBOARD_CLASS_UTILIZATION_INSIGHTS = 'PARTNER_DASHBOARD_CLASS_UTILIZATION_INSIGHTS';
export const PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT = 'PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT';
export const PARTNER_DASHBOARD_SERVICE_PRICING_PROOF = 'PARTNER_DASHBOARD_SERVICE_PRICING_PROOF';
export const PARTNER_DASHBOARD_SMART_RATE = 'PARTNER_DASHBOARD_SMART_RATE';

export const OPTIMIZELY_FEATURE_FLAGS_KEYS = {
  [PARTNER_MIGRATION_SSR_USERS_INFO]: 'partner_migration_ssr_users_info',
  [PARTNER_DASHBOARD_UNLOCK_CLASS_LEVEL_CAMPAIGNS]: 'partner_dashboard_-_unlock_class-level_campaigns',
  [PARTNER_DASHBOARD_SMARTSPOT_ONBOARDING]: 'partner_dashboard_smartspot_onboarding',
  [PARTNER_DASHBOARD_SMARTSPOT_CHART]: 'partner_dashboard_smartspot_chart',
  [PARTNER_DASHBOARD_CLASS_UTILIZATION_INSIGHTS]: 'partner_dashboard_class_utilization_insights',
  [PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT]: 'partner_dashboard_trial_program_mode_edit',
  [PARTNER_DASHBOARD_SERVICE_PRICING_PROOF]: 'partner_dashboard_service_pricing_proof',
  [PARTNER_DASHBOARD_SMART_RATE]: 'partner_dashboard_smartrate',
};
